module.exports = __webpack_public_path__ + "img/banner_kpis.c90aa837.jpg";